import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RequestOptions, RequestMethod, Response, RequestOptionsArgs, Http, Headers, ResponseContentType } from '@angular/http';
import { Observable, Subscription } from 'rxjs/Rx';
import { FadeLED } from '../../Models/LedModels';


@Component({
  selector: 'LedFaded',
  template: require('.//LedFaded.component.html'),
  styles: [require('.//LedFaded.component.css')]
})
export class LedFaded implements OnInit {

  private _opacity: number = 1;
  private _IsPlaying: boolean = false;
  private _transition: string = "0";

  @Input() color: string = "blue";
  @Input()
  set transition(value: string) {
    this._transition = value;
  }

  get transition(): string {
    if (this._IsPlaying)
      return "opacity " + this._transition + "ms ease-in-out";
    else

    return "opacity 0ms ease-in-out";
  }

  @Input()
  set IsPlaying(value: boolean) {
    this._IsPlaying = value;
  }

  get IsPlaying(): boolean {
    return this._IsPlaying
  }

  @Input()
  set Opacity(value: number) {
    this._opacity = value / 255;
    if (this.IsPlaying == false)
      this.OpacityChanged.emit(value);
  }

  get Opacity(): number {
    return this._opacity * 255;
  }

  @Output() OpacityChanged = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit() {
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Components/LedFaded/LedFaded.component.ts
 **/